import { Injectable } from '@angular/core';
import {
  Rpfi17ProviderGroup,
  Rpfi17Row,
  Rpfi17TableResult,
  Rpfi17Totals,
} from '../../models/report/rpfi17.model';

@Injectable({ providedIn: 'root' })
export class MapperRpfi17Service {
  mapTable(res: unknown): Rpfi17TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const groups = (raw['groups'] ?? raw['Groups'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      groups: groups.map((g) => this.mapGroup(g)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapGroup(dto: unknown): Rpfi17ProviderGroup {
    const g = (dto ?? {}) as Record<string, unknown>;
    const rows = (g['rows'] ?? g['Rows'] ?? []) as unknown[];
    return {
      providerUserId: Number(
        g['providerUserId'] ?? g['ProviderUserId'] ?? g['providerCustomerId'] ?? g['ProviderCustomerId'] ?? 0,
      ),
      providerName: String(g['providerName'] ?? g['ProviderName'] ?? ''),
      rows: rows.map((r) => this.mapRow(r)),
      stampCount: Number(g['stampCount'] ?? g['StampCount'] ?? 0),
    };
  }

  private mapRow(dto: unknown): Rpfi17Row {
    const r = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(r['seq'] ?? r['Seq'] ?? 0),
      stampCondition: String(r['stampCondition'] ?? r['StampCondition'] ?? ''),
      license: String(r['license'] ?? r['License'] ?? ''),
      entryDateTime: (r['entryDateTime'] ?? r['EntryDateTime'] ?? null) as string | null,
      exitDateTime: (r['exitDateTime'] ?? r['ExitDateTime'] ?? null) as string | null,
      parkingDuration: String(r['parkingDuration'] ?? r['ParkingDuration'] ?? ''),
      stamperName: String(r['stamperName'] ?? r['StamperName'] ?? ''),
      remark: String(r['remark'] ?? r['Remark'] ?? ''),
    };
  }

  private mapTotals(dto: unknown): Rpfi17Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      stampCount: Number(t['stampCount'] ?? t['StampCount'] ?? 0),
    };
  }
}
